// extracted by mini-css-extract-plugin
export default {"ConteinerPesquisa":"estilo_ConteinerPesquisa__aClq4"};